import { useComputedColorScheme } from "@mantine/core";

export function useBadgeVariant(): "light" | "filled" {
  return useComputedColorScheme("light") === "dark" ? "light" : "filled";
}
